// Copyright (c) 2024 Deere & Company

import DealerAccountsFacet, {getDefaultState as getDealerAccountsFacetDefaultState} from '../../../shared/state/dealer-accounts-facet';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import t from 'tcomb';

const Facets = t.struct({
    dealerAccountsFacet: DealerAccountsFacet,
    deliveryDateRange: t.struct({
        dateRange: DateRange,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    }),
    registrationDateRange: t.struct({
        dateRange: DateRange,
        maxDate: t.maybe(t.Number),
        minDate: t.maybe(t.Number)
    })
}, 'Facets');

export const getDefaultState = () =>
    new Facets({
        dealerAccountsFacet: getDealerAccountsFacetDefaultState(),
        deliveryDateRange: {
            dateRange: {
                from: null,
                to: null
            },
            maxDate: null,
            minDate: null

        },
        registrationDateRange: {
            dateRange: {
                from: null,
                to: null
            },
            maxDate: null,
            minDate: null
        }
    });

export default Facets;



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/state/facets.js